// removed by extract-text-webpack-plugin
module.exports = {"base":"Stub_base--3Lcld","holder":"Stub_holder--1CiZz","title":"Stub_title--3ZRW1","description":"Stub_description---Ezeo"};


//////////////////
// WEBPACK FOOTER
// ./containers/Stub/Stub.scss
// module id = 2485
// module chunks = 16